/**
 * 隔离 import.meta.url，便于 Jest mock（T-A17）。
 */
export function createImageCompressWorker() {
  return new Worker(new URL('./imageCompress.worker.js', import.meta.url));
}
